<template>
    <div class="collapsible-content" :class="{'collapsible-content--open' : isOpen}">
        <div class="collabsible-content__header" @click="toggleOpen">
            <slot name="header"></slot>
        </div>

        <transition name="slide">
          <div class="collapsible-content__body" v-show="isOpen">
              <slot name="body" v-show="isOpen"></slot>
          </div>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'CollapsibleContent',
  props: {
    open: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  watch: {
    open (value) {
      this.isOpen = value
    }
  },
  methods: {
    toggleOpen () {
      if (!this.disabled) {
        this.isOpen = !this.isOpen
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-content__body {
  max-height: 1000px;
  overflow: hidden;
}
.slide-enter-active {
  transition: opacity .25s ease, max-height 1s ease-in-out;
}
.slide-leave-active {
  transition: opacity .25s ease, max-height 0.5s cubic-bezier(0, 1, 0, 1);
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
